import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Serviços',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Esplanada disponível',
    [STORE_SERVICES.DINE_IN]: 'Refeição no local',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Encomenda online via Foodamigos',
    [STORE_SERVICES.RESERVATION]: 'Reservas via Foodamigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reservas no restaurante',
  },
  labels: {
    reservation_total_seats: 'Total de lugares para reserva',
    catering_min_people: 'Mínimo de pessoas para catering',
  },
};
